module.exports = __webpack_public_path__ + "static/media/systray_305.b7bbc7f2.ico";